import { observer } from 'mobx-react';
import { PayTable } from '../../platform/components/pay-table/PayTable';
import { ModalWrapper } from '../../platform/components/modal/ModalWrapper';
import { utilsStore } from '../../platform/stores';
import './PayTableModal.scss';

export const PayTableModal = observer(() => {
  const { showPayTableModal, setShowPayTableModal } = utilsStore;

  const close = () => {
    setShowPayTableModal(false);
  }

  return (
    <ModalWrapper
      hidden={!showPayTableModal}
      onClose={() => close()}>
      <div className="pay-table-modal-component">
        <PayTable/>
      </div>
    </ModalWrapper>
  );
});
